module.exports = __webpack_public_path__ + "static/media/3DCASE.8498b12c.webp";